export const IMAGE_UPLOAD_BATCH_SIZE = 20
export const MAX_UPLOAD_RETRIES = 10
export const RETRY_INTERVAL = 5000
export const UPLOAD_INTERVAL = 2000
